/* tslint:disable */
/* eslint-disable */
/**
 * Dataland Backend API documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../../../../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../../../../../base';
// @ts-ignore
import type { CompanyAssociatedDataSfdrData } from '../../../../../../org/dataland/datalandfrontend/openApiClient/backend/model';
// @ts-ignore
import type { DataAndMetaInformationSfdrData } from '../../../../../../org/dataland/datalandfrontend/openApiClient/backend/model';
// @ts-ignore
import type { DataMetaInformation } from '../../../../../../org/dataland/datalandfrontend/openApiClient/backend/model';
// @ts-ignore
import type { ErrorResponse } from '../../../../../../org/dataland/datalandfrontend/openApiClient/backend/model';
// @ts-ignore
import type { ExportJobInfo } from '../../../../../../org/dataland/datalandfrontend/openApiClient/backend/model';
// @ts-ignore
import type { ExportLatestRequestData } from '../../../../../../org/dataland/datalandfrontend/openApiClient/backend/model';
// @ts-ignore
import type { ExportRequestData } from '../../../../../../org/dataland/datalandfrontend/openApiClient/backend/model';
/**
 * SfdrDataControllerApi - axios parameter creator
 */
export const SfdrDataControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} companyId The unique identifier under which a company can be found on Dataland.
         * @param {boolean} [showOnlyActive] Boolean parameter. If set to true or empty, only currently active data is returned. If set to false, all data is returned regardless of active status.
         * @param {string} [reportingPeriod] The relevant reporting period (e.g. a fiscal year).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCompanySfdrData: async (companyId: string, showOnlyActive?: boolean, reportingPeriod?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('getAllCompanySfdrData', 'companyId', companyId)
            const localVarPath = `/data/sfdr/companies/{companyId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            if (showOnlyActive !== undefined) {
                localVarQueryParameter['showOnlyActive'] = showOnlyActive;
            }

            if (reportingPeriod !== undefined) {
                localVarQueryParameter['reportingPeriod'] = reportingPeriod;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} dataId The unique identifier of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyAssociatedSfdrData: async (dataId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataId' is not null or undefined
            assertParamExists('getCompanyAssociatedSfdrData', 'dataId', dataId)
            const localVarPath = `/data/sfdr/{dataId}`
                .replace(`{${"dataId"}}`, encodeURIComponent(String(dataId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} reportingPeriod The relevant reporting period (e.g. a fiscal year).
         * @param {string} companyId The unique identifier under which a company can be found on Dataland.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyAssociatedSfdrDataByDimensions: async (reportingPeriod: string, companyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportingPeriod' is not null or undefined
            assertParamExists('getCompanyAssociatedSfdrDataByDimensions', 'reportingPeriod', reportingPeriod)
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('getCompanyAssociatedSfdrDataByDimensions', 'companyId', companyId)
            const localVarPath = `/data/sfdr/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            if (reportingPeriod !== undefined) {
                localVarQueryParameter['reportingPeriod'] = reportingPeriod;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identifier Unique identifier to find a company.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestAvailableCompanyAssociatedSfdrData: async (identifier: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identifier' is not null or undefined
            assertParamExists('getLatestAvailableCompanyAssociatedSfdrData', 'identifier', identifier)
            const localVarPath = `/data/sfdr/latest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            if (identifier !== undefined) {
                localVarQueryParameter['identifier'] = identifier;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompanyAssociatedDataSfdrData} companyAssociatedDataSfdrData 
         * @param {boolean} [bypassQa] If true, data is not sent to QA.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCompanyAssociatedSfdrData: async (companyAssociatedDataSfdrData: CompanyAssociatedDataSfdrData, bypassQa?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyAssociatedDataSfdrData' is not null or undefined
            assertParamExists('postCompanyAssociatedSfdrData', 'companyAssociatedDataSfdrData', companyAssociatedDataSfdrData)
            const localVarPath = `/data/sfdr`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            if (bypassQa !== undefined) {
                localVarQueryParameter['bypassQa'] = bypassQa;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(companyAssociatedDataSfdrData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ExportRequestData} exportRequestData 
         * @param {boolean} [keepValueFieldsOnly] If set to true, data is to be exported without additional information like comments on the data or the data\&#39;s qa status.
         * @param {boolean} [includeAliases] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postExportJobCompanyAssociatedSfdrDataByDimensions: async (exportRequestData: ExportRequestData, keepValueFieldsOnly?: boolean, includeAliases?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exportRequestData' is not null or undefined
            assertParamExists('postExportJobCompanyAssociatedSfdrDataByDimensions', 'exportRequestData', exportRequestData)
            const localVarPath = `/data/sfdr/export-jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            if (keepValueFieldsOnly !== undefined) {
                localVarQueryParameter['keepValueFieldsOnly'] = keepValueFieldsOnly;
            }

            if (includeAliases !== undefined) {
                localVarQueryParameter['includeAliases'] = includeAliases;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exportRequestData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ExportLatestRequestData} exportLatestRequestData 
         * @param {boolean} [keepValueFieldsOnly] If set to true, data is to be exported without additional information like comments on the data or the data\&#39;s qa status.
         * @param {boolean} [includeAliases] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postExportLatestJobCompanyAssociatedSfdrDataByDimensions: async (exportLatestRequestData: ExportLatestRequestData, keepValueFieldsOnly?: boolean, includeAliases?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exportLatestRequestData' is not null or undefined
            assertParamExists('postExportLatestJobCompanyAssociatedSfdrDataByDimensions', 'exportLatestRequestData', exportLatestRequestData)
            const localVarPath = `/data/sfdr/export-latest-jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            if (keepValueFieldsOnly !== undefined) {
                localVarQueryParameter['keepValueFieldsOnly'] = keepValueFieldsOnly;
            }

            if (includeAliases !== undefined) {
                localVarQueryParameter['includeAliases'] = includeAliases;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exportLatestRequestData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SfdrDataControllerApi - functional programming interface
 */
export const SfdrDataControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SfdrDataControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} companyId The unique identifier under which a company can be found on Dataland.
         * @param {boolean} [showOnlyActive] Boolean parameter. If set to true or empty, only currently active data is returned. If set to false, all data is returned regardless of active status.
         * @param {string} [reportingPeriod] The relevant reporting period (e.g. a fiscal year).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllCompanySfdrData(companyId: string, showOnlyActive?: boolean, reportingPeriod?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DataAndMetaInformationSfdrData>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllCompanySfdrData(companyId, showOnlyActive, reportingPeriod, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SfdrDataControllerApi.getAllCompanySfdrData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} dataId The unique identifier of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyAssociatedSfdrData(dataId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyAssociatedDataSfdrData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyAssociatedSfdrData(dataId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SfdrDataControllerApi.getCompanyAssociatedSfdrData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} reportingPeriod The relevant reporting period (e.g. a fiscal year).
         * @param {string} companyId The unique identifier under which a company can be found on Dataland.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyAssociatedSfdrDataByDimensions(reportingPeriod: string, companyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyAssociatedDataSfdrData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyAssociatedSfdrDataByDimensions(reportingPeriod, companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SfdrDataControllerApi.getCompanyAssociatedSfdrDataByDimensions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} identifier Unique identifier to find a company.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestAvailableCompanyAssociatedSfdrData(identifier: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyAssociatedDataSfdrData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestAvailableCompanyAssociatedSfdrData(identifier, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SfdrDataControllerApi.getLatestAvailableCompanyAssociatedSfdrData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CompanyAssociatedDataSfdrData} companyAssociatedDataSfdrData 
         * @param {boolean} [bypassQa] If true, data is not sent to QA.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCompanyAssociatedSfdrData(companyAssociatedDataSfdrData: CompanyAssociatedDataSfdrData, bypassQa?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataMetaInformation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCompanyAssociatedSfdrData(companyAssociatedDataSfdrData, bypassQa, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SfdrDataControllerApi.postCompanyAssociatedSfdrData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ExportRequestData} exportRequestData 
         * @param {boolean} [keepValueFieldsOnly] If set to true, data is to be exported without additional information like comments on the data or the data\&#39;s qa status.
         * @param {boolean} [includeAliases] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postExportJobCompanyAssociatedSfdrDataByDimensions(exportRequestData: ExportRequestData, keepValueFieldsOnly?: boolean, includeAliases?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExportJobInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postExportJobCompanyAssociatedSfdrDataByDimensions(exportRequestData, keepValueFieldsOnly, includeAliases, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SfdrDataControllerApi.postExportJobCompanyAssociatedSfdrDataByDimensions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ExportLatestRequestData} exportLatestRequestData 
         * @param {boolean} [keepValueFieldsOnly] If set to true, data is to be exported without additional information like comments on the data or the data\&#39;s qa status.
         * @param {boolean} [includeAliases] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postExportLatestJobCompanyAssociatedSfdrDataByDimensions(exportLatestRequestData: ExportLatestRequestData, keepValueFieldsOnly?: boolean, includeAliases?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExportJobInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postExportLatestJobCompanyAssociatedSfdrDataByDimensions(exportLatestRequestData, keepValueFieldsOnly, includeAliases, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SfdrDataControllerApi.postExportLatestJobCompanyAssociatedSfdrDataByDimensions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SfdrDataControllerApi - factory interface
 */
export const SfdrDataControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SfdrDataControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} companyId The unique identifier under which a company can be found on Dataland.
         * @param {boolean} [showOnlyActive] Boolean parameter. If set to true or empty, only currently active data is returned. If set to false, all data is returned regardless of active status.
         * @param {string} [reportingPeriod] The relevant reporting period (e.g. a fiscal year).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCompanySfdrData(companyId: string, showOnlyActive?: boolean, reportingPeriod?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DataAndMetaInformationSfdrData>> {
            return localVarFp.getAllCompanySfdrData(companyId, showOnlyActive, reportingPeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} dataId The unique identifier of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyAssociatedSfdrData(dataId: string, options?: RawAxiosRequestConfig): AxiosPromise<CompanyAssociatedDataSfdrData> {
            return localVarFp.getCompanyAssociatedSfdrData(dataId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} reportingPeriod The relevant reporting period (e.g. a fiscal year).
         * @param {string} companyId The unique identifier under which a company can be found on Dataland.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyAssociatedSfdrDataByDimensions(reportingPeriod: string, companyId: string, options?: RawAxiosRequestConfig): AxiosPromise<CompanyAssociatedDataSfdrData> {
            return localVarFp.getCompanyAssociatedSfdrDataByDimensions(reportingPeriod, companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identifier Unique identifier to find a company.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestAvailableCompanyAssociatedSfdrData(identifier: string, options?: RawAxiosRequestConfig): AxiosPromise<CompanyAssociatedDataSfdrData> {
            return localVarFp.getLatestAvailableCompanyAssociatedSfdrData(identifier, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompanyAssociatedDataSfdrData} companyAssociatedDataSfdrData 
         * @param {boolean} [bypassQa] If true, data is not sent to QA.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCompanyAssociatedSfdrData(companyAssociatedDataSfdrData: CompanyAssociatedDataSfdrData, bypassQa?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<DataMetaInformation> {
            return localVarFp.postCompanyAssociatedSfdrData(companyAssociatedDataSfdrData, bypassQa, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExportRequestData} exportRequestData 
         * @param {boolean} [keepValueFieldsOnly] If set to true, data is to be exported without additional information like comments on the data or the data\&#39;s qa status.
         * @param {boolean} [includeAliases] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postExportJobCompanyAssociatedSfdrDataByDimensions(exportRequestData: ExportRequestData, keepValueFieldsOnly?: boolean, includeAliases?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<ExportJobInfo> {
            return localVarFp.postExportJobCompanyAssociatedSfdrDataByDimensions(exportRequestData, keepValueFieldsOnly, includeAliases, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExportLatestRequestData} exportLatestRequestData 
         * @param {boolean} [keepValueFieldsOnly] If set to true, data is to be exported without additional information like comments on the data or the data\&#39;s qa status.
         * @param {boolean} [includeAliases] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postExportLatestJobCompanyAssociatedSfdrDataByDimensions(exportLatestRequestData: ExportLatestRequestData, keepValueFieldsOnly?: boolean, includeAliases?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<ExportJobInfo> {
            return localVarFp.postExportLatestJobCompanyAssociatedSfdrDataByDimensions(exportLatestRequestData, keepValueFieldsOnly, includeAliases, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SfdrDataControllerApi - interface
 */
export interface SfdrDataControllerApiInterface {
    /**
     * 
     * @param {string} companyId The unique identifier under which a company can be found on Dataland.
     * @param {boolean} [showOnlyActive] Boolean parameter. If set to true or empty, only currently active data is returned. If set to false, all data is returned regardless of active status.
     * @param {string} [reportingPeriod] The relevant reporting period (e.g. a fiscal year).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAllCompanySfdrData(companyId: string, showOnlyActive?: boolean, reportingPeriod?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DataAndMetaInformationSfdrData>>;

    /**
     * 
     * @param {string} dataId The unique identifier of the dataset.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompanyAssociatedSfdrData(dataId: string, options?: RawAxiosRequestConfig): AxiosPromise<CompanyAssociatedDataSfdrData>;

    /**
     * 
     * @param {string} reportingPeriod The relevant reporting period (e.g. a fiscal year).
     * @param {string} companyId The unique identifier under which a company can be found on Dataland.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompanyAssociatedSfdrDataByDimensions(reportingPeriod: string, companyId: string, options?: RawAxiosRequestConfig): AxiosPromise<CompanyAssociatedDataSfdrData>;

    /**
     * 
     * @param {string} identifier Unique identifier to find a company.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLatestAvailableCompanyAssociatedSfdrData(identifier: string, options?: RawAxiosRequestConfig): AxiosPromise<CompanyAssociatedDataSfdrData>;

    /**
     * 
     * @param {CompanyAssociatedDataSfdrData} companyAssociatedDataSfdrData 
     * @param {boolean} [bypassQa] If true, data is not sent to QA.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postCompanyAssociatedSfdrData(companyAssociatedDataSfdrData: CompanyAssociatedDataSfdrData, bypassQa?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<DataMetaInformation>;

    /**
     * 
     * @param {ExportRequestData} exportRequestData 
     * @param {boolean} [keepValueFieldsOnly] If set to true, data is to be exported without additional information like comments on the data or the data\&#39;s qa status.
     * @param {boolean} [includeAliases] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postExportJobCompanyAssociatedSfdrDataByDimensions(exportRequestData: ExportRequestData, keepValueFieldsOnly?: boolean, includeAliases?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<ExportJobInfo>;

    /**
     * 
     * @param {ExportLatestRequestData} exportLatestRequestData 
     * @param {boolean} [keepValueFieldsOnly] If set to true, data is to be exported without additional information like comments on the data or the data\&#39;s qa status.
     * @param {boolean} [includeAliases] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postExportLatestJobCompanyAssociatedSfdrDataByDimensions(exportLatestRequestData: ExportLatestRequestData, keepValueFieldsOnly?: boolean, includeAliases?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<ExportJobInfo>;

}

/**
 * SfdrDataControllerApi - object-oriented interface
 */
export class SfdrDataControllerApi extends BaseAPI implements SfdrDataControllerApiInterface {
    /**
     * 
     * @param {string} companyId The unique identifier under which a company can be found on Dataland.
     * @param {boolean} [showOnlyActive] Boolean parameter. If set to true or empty, only currently active data is returned. If set to false, all data is returned regardless of active status.
     * @param {string} [reportingPeriod] The relevant reporting period (e.g. a fiscal year).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAllCompanySfdrData(companyId: string, showOnlyActive?: boolean, reportingPeriod?: string, options?: RawAxiosRequestConfig) {
        return SfdrDataControllerApiFp(this.configuration).getAllCompanySfdrData(companyId, showOnlyActive, reportingPeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} dataId The unique identifier of the dataset.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCompanyAssociatedSfdrData(dataId: string, options?: RawAxiosRequestConfig) {
        return SfdrDataControllerApiFp(this.configuration).getCompanyAssociatedSfdrData(dataId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} reportingPeriod The relevant reporting period (e.g. a fiscal year).
     * @param {string} companyId The unique identifier under which a company can be found on Dataland.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCompanyAssociatedSfdrDataByDimensions(reportingPeriod: string, companyId: string, options?: RawAxiosRequestConfig) {
        return SfdrDataControllerApiFp(this.configuration).getCompanyAssociatedSfdrDataByDimensions(reportingPeriod, companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identifier Unique identifier to find a company.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getLatestAvailableCompanyAssociatedSfdrData(identifier: string, options?: RawAxiosRequestConfig) {
        return SfdrDataControllerApiFp(this.configuration).getLatestAvailableCompanyAssociatedSfdrData(identifier, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompanyAssociatedDataSfdrData} companyAssociatedDataSfdrData 
     * @param {boolean} [bypassQa] If true, data is not sent to QA.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postCompanyAssociatedSfdrData(companyAssociatedDataSfdrData: CompanyAssociatedDataSfdrData, bypassQa?: boolean, options?: RawAxiosRequestConfig) {
        return SfdrDataControllerApiFp(this.configuration).postCompanyAssociatedSfdrData(companyAssociatedDataSfdrData, bypassQa, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExportRequestData} exportRequestData 
     * @param {boolean} [keepValueFieldsOnly] If set to true, data is to be exported without additional information like comments on the data or the data\&#39;s qa status.
     * @param {boolean} [includeAliases] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postExportJobCompanyAssociatedSfdrDataByDimensions(exportRequestData: ExportRequestData, keepValueFieldsOnly?: boolean, includeAliases?: boolean, options?: RawAxiosRequestConfig) {
        return SfdrDataControllerApiFp(this.configuration).postExportJobCompanyAssociatedSfdrDataByDimensions(exportRequestData, keepValueFieldsOnly, includeAliases, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExportLatestRequestData} exportLatestRequestData 
     * @param {boolean} [keepValueFieldsOnly] If set to true, data is to be exported without additional information like comments on the data or the data\&#39;s qa status.
     * @param {boolean} [includeAliases] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postExportLatestJobCompanyAssociatedSfdrDataByDimensions(exportLatestRequestData: ExportLatestRequestData, keepValueFieldsOnly?: boolean, includeAliases?: boolean, options?: RawAxiosRequestConfig) {
        return SfdrDataControllerApiFp(this.configuration).postExportLatestJobCompanyAssociatedSfdrDataByDimensions(exportLatestRequestData, keepValueFieldsOnly, includeAliases, options).then((request) => request(this.axios, this.basePath));
    }
}

